import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import type { AxiosResponse } from 'axios';

export type LookerReport = {
  id: string;
  name: string;
  url: string;
  index: number;
};

export type DeleteDashboardReportResponse = {
  'looker-reports': LookerReport[];
};

export type DeleteDashboardReportPayload = {
  name: string;
  url: string;
};

export const DELETE_DASHBOARD_REPORT_RQ_KEY = 'DeleteDashboardReport';

const deleteDashboardReport = async (
  projectId: string,
  reportId: string,
  payload: DeleteDashboardReportPayload
): Promise<AxiosResponse<DeleteDashboardReportResponse>> => {
  return axios.delete(`/api/projects/${projectId}/settings/dashboard/reports/${reportId}`, {
    data: payload,
  });
};

export const useDeleteDashboardReport = (
  projectId: string,
  reportId: string,
  options: UseMutationOptions<
    AxiosResponse<DeleteDashboardReportResponse>,
    Error,
    DeleteDashboardReportPayload
  > = {}
) => {
  return useMutation<
    AxiosResponse<DeleteDashboardReportResponse>,
    Error,
    DeleteDashboardReportPayload
  >(
    [DELETE_DASHBOARD_REPORT_RQ_KEY, projectId, reportId],
    (payload: DeleteDashboardReportPayload) => deleteDashboardReport(projectId, reportId, payload),
    options
  );
};
